
<template>
 
  <el-dialog v-dialogDrag :visible.sync="localVisible" v-if="localVisible" :destroy-on-close="true" width="450px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
      <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
          <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{v_title}}</span>
      </div>
      <div style="line-height:30px;display:flex">
          <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
          <div style="font-size:12px;line-height:30px; ">{{message}}</div>
      </div>
      <span slot="footer"  >
          <el-button type="primary" size="small" @click="handleConfirm()">{{v_ok}}</el-button>
      </span>
  </el-dialog>
 
</template>

<script>
export default {
  name: 'PromptDialog',
  props: {
    v_win: {
      type: Boolean,
      default: false
    },
 
    message: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      localVisible:this.v_win,
      v_ok:'',
      v_title:'',
    }
  },
  mounted () {
    this.v_title =this.$store.state.lang=='CN'?'系统提示': 'System Prompt' 
    this.v_ok =this.$store.state.lang=='CN'?'确 定': 'Sure'  
  },
  watch: {
    v_win(newVal) {
      this.localVisible = newVal // 监听prop变化并更新本地状态
    }
  },
  methods: {
    handleConfirm() {
      this.localVisible = false
      this.$emit('child-exit')
    }
  }
}
</script>
